module.exports = "/assets/packs/images/8471b4964ba204d6df340c114464ee46.svg";